<template>
    <div class="mx-4">
        <v-row
            no-gutters
            v-for="(type, index) of importMapping"
            :key="`connector-import-mapping-${index}`"
            class="my-1"
            style="min-width: 850px"
        >
            <v-col>
                {{ type.key }}
            </v-col>
            <v-col>
                <AccountableAccount
                    v-model="type.value"
                    :companyId="companyId"
                    :inputStyle="'padding: 10px; margin:0px;'"
                    :showSuggestion="false"
                    :showDescription="true"
                    :showValidation="false"
                    :mandatory="false"
                    :inAccountableAccountType="'IncomingOutgoing'"
                    hide-details
                    @select-accountableAccount="selectAccountableAccount"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script lang="ts">
import AccountableAccount from "@/views/AccountableAccount.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {
        AccountableAccount,
    },
    emits: ["accountChange"],
})
export class SettingConnectorImportMapping extends Vue {
    @Prop() importMapping!: any[];
    @Prop() companyId!: string;

    selectAccountableAccount(account: any) {
        debugger;
        this.$emit("accountChange", account);
    }
}

export default toNative(SettingConnectorImportMapping);
</script>
